<template>
  <div v-cloak>
    <select style="width:100%;display:none;" :multiple="multiple ? 'multiple' : false" ref="cmp">
      <slot></slot>
    </select>
  </div>
</template>

<script>
import loadjs from "loadjs";

export default {
  props: {
    placeholder: {
      type: String,
      default: "--请选择--"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    scope: {
      type: Object,
      default: null
    }
  },
  created() {
    let vm = this;
    loadjs(["/bootstrap/vendor/select2/js/select2.min.js"], function() {
      let $select2 = $(vm.$refs.cmp).select2({
        placeholder: vm.placeholder,
        allowClear: true
      });
      vm.$select2 = $select2;
      $(vm.$refs.cmp).on("change.select2", function() {
        let v = $select2.val();
        let text = $select2.find('option[value="' + v + '"]').text();
        if (v instanceof Array) {
          text = [];
          v.forEach((it, idx) => {
            text.push($select2.find('option[value="' + v[idx] + '"]').text());
          });
        }
        vm.$emit("change", v, vm.scope, {
          text,
          value: v
        });
      });
    });
    if (document.getElementById("select2Css")) return;
    let firstLink = document.getElementsByTagName("link")[0];
    let link = document.createElement("link");
    link.id = "select2Css";
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("href", "/bootstrap/vendor/select2/css/select2.min.css");
    document.head.insertBefore(link, firstLink);
  },
  destroyed() {
    let vm = this;
    $(vm.$refs.cmp).select2("destroy");
  },
  methods: {
    clear() {
      this.$select2.val(null).trigger("change");
    }
  }
};
</script>